<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .teammate-row {
    align-items: center;
    background-color: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    gap: utils.in_rem(12px);
    padding: utils.in_rem(8px) utils.in_rem(12px);
    transition: background-color 0.15s ease;
    width: 100%;

    &:hover {
      background-color: colors.get(interfaceTransparentWhite_15);
    }

    .info {
      display: flex;
      flex: 1;
      flex-direction: column;
      gap: utils.in_rem(2px);
      min-width: 0;

      .name {
        color: colors.get(textWhite);
        @include mixins.body3;
        font-weight: 500;
        line-height: 1.2;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .phone {
        color: colors.get(interfaceTransparentWhite_70);
        @include mixins.body4;
        line-height: 1.2;
        overflow: hidden;
        text-align: left;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .section-header {
    color: colors.get(interfaceTransparentWhite_70);
    @include mixins.body4;
    font-weight: 600;
    padding: utils.in_rem(8px);
    background-color: colors.get(interfaceTransparentBlack_30);
  }
</style>

<script>
  import DiallerAvatar from "./DiallerAvatar.svelte";

  let {
    teammate = {},
    showSectionHeader = false,
    sectionLetter = "",
    onclick = () => {},
  } = $props();

  const fullName = $derived(
    (teammate.firstName + " " + teammate.lastName).trim()
  );
</script>

{#if showSectionHeader}
  <div class="section-header">{sectionLetter}</div>
{/if}

<button
  class="teammate-row"
  type="button"
  {onclick}
  aria-label="Add {fullName} to call"
>
  <DiallerAvatar
    firstName={teammate.firstName || ""}
    lastName={teammate.lastName || ""}
    size="small"
    state="teammate"
    alt={fullName}
  />
  <div class="info">
    <div class="name">{fullName}</div>
    <div class="phone">{teammate.phone || ""}</div>
  </div>
</button>
